import React, { useState } from "react";
import {
  Modal,
  Card,
  CardContent,
  Button,
  Grid,
  Typography
} from "@material-ui/core";
import { styleEndowment } from "./styleEndowment";

function getModalStyle() {
  const top = 50;
  const left = 50;

  return {
    top: `${top}%`,
    left: `${left}%`,
    transform: `translate(-${top}%, -${left}%)`,
  };
}

const SeeEndowmentModal = ({
    openModal,
    closeModal,
    endowments,
    cardTypeList,
    otherTypeList    
}) => {
    const classes = styleEndowment();
    const [modalStyle] = useState(getModalStyle);   
  
    const bodyModal = (
      <div style={modalStyle} className={classes.contModalDownload}>
        <Card className={classes.card} elevation={0} >
        <CardContent className={classes.bodyModal}>

          <div className={classes.contAccordion}>
            <p style={{textAlign: 'center', fontSize: 20}}>
                Información dotación
            </p>

            <>
              {
                endowments?.length === 0 && cardTypeList?.length === 0 && otherTypeList?.length === 0
                  ? <Typography style={{textAlign: 'center'}}>El formato no cuenta con registros de dotación</Typography>
                  : <>
                      <Grid container>
                        {endowments?.map((endowmen) => (
                          <Grid container style={{margin: '4px 0'}}>
                            <Grid item xs={12} md={6} lg={6}>
                              <Typography className={classes.heading}>{endowmen?.typeEndowment?.description}</Typography>
                            </Grid> 
                            <Grid item xs={12} md={3} lg={3}>
                              <Typography className={classes.heading}>Talla</Typography>
                              <Typography className={classes.secondaryHeading}>{endowmen?.size}</Typography>
                            </Grid>
                            <Grid item xs={12} md={3} lg={3}>
                              <Typography className={classes.heading}>Cantidad</Typography>
                              <Typography className={classes.secondaryHeading}>{endowmen?.amount}</Typography>
                            </Grid>
                          </Grid>
                        ))}
                      </Grid>

                      <Grid container>
                        {cardTypeList?.map((card) => (
                          <Grid container style={{margin: '4px 0'}}>
                            <Grid item xs={12} md={6} lg={6}>
                              <Typography className={classes.heading}>{card?.typeEndowment?.description}</Typography>
                            </Grid> 
                            <Grid item xs={12} md={3} lg={3}></Grid>
                            <Grid item xs={12} md={3} lg={3}>
                              <Typography className={classes.heading}>Cantidad</Typography>
                              <Typography className={classes.secondaryHeading}>{card?.amount}</Typography>
                            </Grid>
                          </Grid>
                        ))}
                      </Grid>

                      <Grid container>
                        {otherTypeList?.map((other) => (
                          <Grid container style={{margin: '4px 0'}}>
                            <Grid item xs={12} md={6} lg={6}>
                              <Typography className={classes.heading}>{other?.typeEndowment?.description}</Typography>
                            </Grid>
                            <Grid item xs={12} md={6} lg={6}>
                              <Typography className={classes.heading}>Observación</Typography>
                              <Typography className={classes.secondaryHeading}>{other?.observation}</Typography>
                            </Grid>
                          </Grid>
                        ))}
                      </Grid>
                    </>    
              }
              </>

            <Grid item xs={12} md={12} lg={12} style={{textAlign: 'center', marginTop: '20px'}}>
                <Button
                    variant='outlined'
                    style={{backgroundColor: 'transparent', color: '#7EBDCE'}}
                    onClick={closeModal}
                >
                    Volver
                </Button>
            </Grid>

          </div>
       </CardContent>
      </Card>
      </div>
    );
  
    return (
      <div>
        <Modal
          open={openModal}
        >
          {bodyModal}
        </Modal>
      </div>
    );
}

export default SeeEndowmentModal;